import { OneShotBinary, NodeWithSize } from '../types';

export const getImageWithoutTextNodes = async (
  node: NodeWithSize,
  textNodes: TextNode[]
): Promise<OneShotBinary<Uint8Array> | null> => {
  const originalOpacity: { [key: string]: number } = {};

  try {
    textNodes.forEach((textNode) => {
      originalOpacity[textNode.id] = textNode.opacity;
      textNode.opacity = 0;
    });
    // scaled 2x for better analysis
    const converted = await node.exportAsync({
      format: 'PNG',
      useAbsoluteBounds: true,
      contentsOnly: false,
    });

    return new OneShotBinary(converted);
  } catch {
    return null;
  } finally {
    textNodes.forEach((textNode) => {
      textNode.opacity = originalOpacity[textNode.id];
    });
  }
};
